import _ from "lodash";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import ConfirmationWindow from "./_ConfirmationWindow";
import DataConflictWindow from "./_DataConflictWindow";
import FormHelperText from "@material-ui/core/FormHelperText";
import "../Styles/_ReturnOrderItemsWindow.css";

let refund_details_scroll_event_added = false;

let isInViewport = (element, box_element) => {
    let element_bounding = element.getBoundingClientRect();
    let box_element_bounding = box_element.getBoundingClientRect();

    return Math.round(element_bounding.top) < Math.round(box_element_bounding.bottom);
};

const getItemPicture = sku => {
    return `https://static.koboscm.com/images/RakutenKobo/devices/${sku}.png`;
};

class ReturnOrderItemsWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnItems: [],
            returnReasonId: null,
            returnErrorMessage: "",
            itemsAvailableForReturn: [],
            returnFinished: false,
            submitErrors: [],
            scrolling: false,
            confirmationWindowOpen: false,
            dataConflictWindowOpen: false
        };
    }

    checkScrollingScroll = () => {
        window.requestAnimationFrame(() => {
            if (
                document.getElementById("sticky-refund-total-return-order") &&
                document.getElementById("return-window-calculation-summary") &&
                isInViewport(document.getElementById("sticky-refund-total-return-order"), document.getElementById("return-window-calculation-summary"))
            ) {
                if (!this.state.scrolling) {
                    this.setState({
                        scrolling: true
                    });
                }
            } else {
                if (this.state.scrolling) {
                    this.setState({
                        scrolling: false
                    });
                }
            }
        });
    };

    checkScrollingResize = () => {
        window.requestAnimationFrame(() => {
            if (
                document.getElementById("sticky-refund-total-return-order") &&
                document.getElementById("return-window-calculation-summary") &&
                isInViewport(document.getElementById("sticky-refund-total-return-order"), document.getElementById("return-window-calculation-summary"))
            ) {
                if (!this.state.scrolling) {
                    this.setState({
                        scrolling: true
                    });
                }
            } else {
                if (this.state.scrolling) {
                    this.setState({
                        scrolling: false
                    });
                }
            }
        });
    };

    componentWillUnmount() {
        this.removeEventListeners();
    }

    componentDidMount() {
        let itemsAvailableForReturn = [];

        this.props.order.sub_orders.forEach(so => {
            so.line_items.forEach(line_item => {
                if (line_item.fulfillable_quantity < line_item.quantity) {
                    let lineItem = Object.assign({}, line_item);
                    itemsAvailableForReturn.push(lineItem);
                }
            });
        });

        this.setState({
            itemsAvailableForReturn
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.resetErrorMessages();
                this.setState({
                    returnFinished: true
                });
            } else {
                this.setState({
                    returnErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.ERROR_FAILED
                });
            }
        }

        if (this.props.returnOrderCalculating === false && prevProps.returnOrderCalculating === true) {
            if (this.props.returnOrderCalculatingError) {
                this.setState({
                    returnErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.ERROR_CALCULATION_FAILED
                });
            } else {
                this.resetErrorMessages();
            }

            this.checkScrollingForRefundTotal();
            this.addEventListeners();
        }

        if (
            (prevProps.returnOrderCalculating === true &&
                this.props.returnOrderCalculating === false &&
                this.props.returnOrderCalculatingError === "conflict") ||
            (prevProps.loading === true && this.props.loading === false && this.props.err === "conflict")
        ) {
            this.setState({
                dataConflictWindowOpen: true
            });
        }

        if (prevProps.open === false && this.props.open === true && this.props.returnReasons.length === 0 && this.props.returnReasonsLoading === false) {
            this.props.getReturnReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetReturnReason();
            this.resetReturnItems();
            this.resetReturnFinished();
            this.props.returnOrderCalculateReset();
            this.resetSubmitErrors();
        }

        if (JSON.stringify(prevState.returnItems) !== JSON.stringify(this.state.returnItems)) {
            this.props.returnOrderCalculate(this.props.match.params.order_id, {
                order: this.props.order,
                items: this.state.returnItems
            });
        }
    }

    resetReturnFinished() {
        this.setState({
            returnFinished: false
        });
    }

    handleNoClick() {
        this.removeEventListeners();
        if (this.state.returnFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    }

    handleYesClick() {
        this.resetSubmitErrors();
        if (this.getSubmitErrors().length === 0) {
            this.handleOpenConfirmationWindow();
        } else {
            this.updateSubmitErrors();
        }
    }

    updateSubmitErrors() {
        this.setState({
            submitErrors: this.getSubmitErrors()
        });
    }

    handleConfirmReturnOrder() {
        this.resetErrorMessages();
        this.handleCloseConfirmationWindow();
        this.returnOrder();
    }

    returnOrder() {
        this.props.returnOrder(
            this.props.order_id,
            {
                order: this.props.order,
                items: this.state.returnItems,
                reason: this.state.returnReasonId
            },
            this.props.language
        );
    }

    getSubmitErrors() {
        let errors = [];

        if (!this.state.returnReasonId) {
            errors.push({
                code: "return_reason",
                label: locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.ERRORS.REASON_REQUIRED
            });
        }

        if (this.state.returnItems.length === 0) {
            errors.push({
                code: "return_items",
                label: locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.ERRORS.CANCEL_ITEMS_REQUIRED
            });
        }

        return errors;
    }

    resetSubmitErrors() {
        this.setState({
            submitErrors: []
        });
    }

    resetErrorMessages() {
        this.setState({
            returnErrorMessage: ""
        });
    }

    handleEnter() {
        this.resetErrorMessages();
        // this.SetBodyScroll();
    }

    SetBodyScroll() {
        let el = document.getElementById("body");

        if (el.style.overflow === "hidden") {
            el.style.overflow = "initial";
        }
    }

    handleReturnItemRemoveClick(lineItem) {
        let returnItems = JSON.parse(JSON.stringify(this.state.returnItems));

        let returnItem = returnItems.filter(i => i.lineItemId === lineItem.line_item_id)[0];

        if (returnItem) {
            if (returnItem.quantity === 1) {
                returnItems = returnItems.filter(i => i.lineItemId !== lineItem.line_item_id);
            } else if (returnItem.quantity > 1) {
                returnItem.quantity = returnItem.quantity - 1;
            }
        }

        this.setState({
            returnItems
        });
    }

    handleReturnItemAddClick(lineItem) {
        let returnItems = JSON.parse(JSON.stringify(this.state.returnItems));

        let returnItem = returnItems.filter(i => i.lineItemId === lineItem.line_item_id)[0];

        if (returnItem) {
            if (returnItem.quantity < lineItem.quantity - lineItem.fulfillable_quantity) {
                returnItem.quantity = returnItem.quantity + 1;
            }
        } else {
            returnItems.push({
                lineItemId: lineItem.line_item_id,
                quantity: 1
            });
        }

        this.setState({
            returnItems
        });
    }

    handleReturnItemQuantityChange(lineItem, e) {
        if (!this.props.returnOrderCalculating && !this.props.loading && !isNaN(e.target.value) && Number(e.target.value) >= 0) {
            let value = Number(e.target.value);
            let returnItems = JSON.parse(JSON.stringify(this.state.returnItems));

            if (returnItems.filter(i => i.lineItemId === lineItem.line_item_id)[0]) {
                if (value === 0) {
                    returnItems = returnItems.filter(i => i.lineItemId !== lineItem.line_item_id);
                } else {
                    let newQuantity = 0;

                    if (value <= lineItem.quantity - lineItem.fulfillable_quantity) {
                        newQuantity = value;
                    } else if (value >= lineItem.quantity - lineItem.fulfillable_quantity) {
                        newQuantity = lineItem.quantity - lineItem.fulfillable_quantity;
                    }
                    returnItems.filter(i => i.lineItemId === lineItem.line_item_id)[0].quantity = newQuantity;
                }
            } else {
                let newQuantity = 0;

                if (value <= lineItem.quantity - lineItem.fulfillable_quantity) {
                    newQuantity = value;
                } else if (value >= lineItem.quantity - lineItem.fulfillable_quantity) {
                    newQuantity = lineItem.quantity - lineItem.fulfillable_quantity;
                }

                returnItems.push({
                    lineItemId: lineItem.line_item_id,
                    quantity: newQuantity
                });
            }

            this.setState({
                returnItems
            });
        }
    }

    returnItemRemoveClickEnabled(lineItem) {
        return this.state.returnItems.filter(i => i.lineItemId === lineItem.line_item_id)[0] !== null;
    }

    returnItemAddClickEnabled(lineItem) {
        let returnItem = this.state.returnItems.filter(i => i.lineItemId === lineItem.line_item_id)[0];

        return !returnItem || returnItem.quantity < lineItem.quantity - lineItem.fulfillable_quantity;
    }

    handleChange(e) {
        switch (e.target.name) {
            case "return-reason":
                this.setState({
                    returnReasonId: e.target.value
                });
                break;

            default:
                break;
        }
    }

    resetReturnReason() {
        this.setState({
            returnReasonId: null
        });
    }

    resetReturnItems() {
        this.setState({
            returnItems: []
        });
    }

    handleSelectAllClick() {
        let returnItems = [];

        this.state.itemsAvailableForReturn.map(lineItem => {
            returnItems.push({
                lineItemId: lineItem.line_item_id,
                quantity: lineItem.quantity - lineItem.fulfillable_quantity
            });
        });

        this.setState({
            returnItems: JSON.parse(JSON.stringify(returnItems))
        });
    }

    selectAllEnabled() {
        return !this.state.itemsAvailableForReturn.every(lineItem =>
            this.state.returnItems.some(
                returnItem => lineItem.line_item_id === returnItem.lineItemId && lineItem.quantity - lineItem.fulfillable_quantity === returnItem.quantity
            )
        );
    }

    handleCloseConfirmationWindow() {
        this.removeEventListeners();
        this.setState({
            confirmationWindowOpen: false
        });
    }

    handleOpenConfirmationWindow() {
        this.setState({
            confirmationWindowOpen: true
        });
    }

    handleRefreshOrder() {
        this.props.handleClose();
        this.props.refreshOrder();
    }

    addEventListeners() {
        let elements = document.getElementsByClassName("order-return-items-dialog-paper");

        if (elements[0]) {
            if (document.getElementById("sticky-refund-total-return-order") && document.getElementById("return-window-calculation-summary")) {
                elements[0].addEventListener("scroll", this.checkScrollingScroll);
                window.addEventListener("resize", this.checkScrollingResize);
                refund_details_scroll_event_added = true;
            }
        }
    }

    removeEventListeners() {
        let elements = document.getElementsByClassName("order-return-items-dialog-paper");
        if (elements[0]) {
            elements[0].removeEventListener("scroll", this.checkScrollingScroll);
        }

        window.removeEventListener("resize", this.checkScrollingResize);

        refund_details_scroll_event_added = false;
    }

    checkScrollingForRefundTotal() {
        if (isInViewport(document.getElementById("sticky-refund-total-return-order"), document.getElementById("return-window-calculation-summary"))) {
            if (!this.state.scrolling) {
                this.setState({
                    scrolling: true
                });
            }
        } else {
            if (this.state.scrolling) {
                this.setState({
                    scrolling: false
                });
            }
        }
    }

    render() {
        return (
            <Dialog
                classes={{ paper: `order-return-items-dialog-paper${this.state.returnFinished ? " completed" : ""}` }}
                className="order-return-items-dialog"
                open={this.props.open || false}
                onEnter={this.handleEnter.bind(this)}
            >
                <div className={`layout vertical order-return-items-window relative${this.state.returnFinished ? " completed" : ""}`}>
                    <div className="order-return-items-window-inner">
                        {(this.state.confirmationWindowOpen || this.state.dataConflictWindowOpen) && <div className="fit layout vertical backdrop-1" />}
                        <div
                            className={`loading-box fit layout vertical center-center${
                                !(this.props.loading || this.props.returnOrderCalculating || this.props.returnReasonsLoading) ? " hidden" : ""
                            }`}
                        >
                            <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                        </div>

                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <p className="title">
                                        {locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.HEADING}
                                    </p>
                                </div>
                            </div>
                        </div>
                        {!this.state.returnFinished && (
                            <div>
                                {this.state.returnErrorMessage && (
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div className="message-box">{this.state.returnErrorMessage}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="box">
                                    <div className="row">
                                        <div className="column">
                                            <div className="sub-title">
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.SUBHEADING}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box" style={{ marginBottom: "0px" }}>
                                    <div className="row" style={{ marginBottom: "0px" }}>
                                        <div className="column">
                                            <div className="flex layout horizontal items-refund-summary">
                                                <div className="flex layout vertical">
                                                    <div className="layout horizontal justified">
                                                        <h2 className="section-title flex">
                                                            {
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS
                                                                    .ITEMS_HEADER
                                                            }
                                                        </h2>
                                                        <div style={{ fontSize: "14px", alignSelf: "center" }}>
                                                            <a
                                                                className={`linked-text${!this.selectAllEnabled() ? " disabled" : ""}`}
                                                                onClick={this.handleSelectAllClick.bind(this)}
                                                            >
                                                                {
                                                                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION
                                                                        .RETURN_ORDER_ITEMS.SELECT_ALL_ITEMS
                                                                }
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="layout horizontal item-list">
                                                        <table className="flex layout vertical">
                                                            <tbody className="flex layout vertical">
                                                                {_.orderBy(this.state.itemsAvailableForReturn, ["price"], ["desc"]).map((li, i) => {
                                                                    return (
                                                                        <tr key={i} className="layout horizontal item">
                                                                            <td>
                                                                                <div className="flex return-order-item-image-box relative">
                                                                                    <img
                                                                                        className="return-order-item-image"
                                                                                        src={getItemPicture(li.sku)}
                                                                                        alt=""
                                                                                    />
                                                                                    <div className="return-order-item-quantity">
                                                                                        {li.quantity - li.fulfillable_quantity}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className="flex return-order-item-description">
                                                                                <span className="layout vertical">
                                                                                    <span>{li.name}</span>
                                                                                    <span>{li.price_formatted}</span>
                                                                                </span>
                                                                            </td>
                                                                            <td className="layout  return-item-quantity-box">
                                                                                <div className="layout horizontal center-center">
                                                                                    <Button
                                                                                        disabled={
                                                                                            !this.state.returnItems.filter(
                                                                                                i => i.lineItemId === li.line_item_id
                                                                                            )[0]
                                                                                        }
                                                                                        onClick={this.handleReturnItemRemoveClick.bind(this, li)}
                                                                                        className="return-item-quantity-change-button"
                                                                                        color="primary"
                                                                                    >
                                                                                        <RemoveIcon />
                                                                                    </Button>
                                                                                    <TextField
                                                                                        className="return-item-quantity"
                                                                                        name="return-item-quantity"
                                                                                        value={
                                                                                            this.state.returnItems.filter(
                                                                                                i => i.lineItemId === li.line_item_id
                                                                                            )[0]
                                                                                                ? this.state.returnItems.filter(
                                                                                                      i => i.lineItemId === li.line_item_id
                                                                                                  )[0].quantity
                                                                                                : ""
                                                                                        }
                                                                                        onChange={this.handleReturnItemQuantityChange.bind(this, li)}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    <Button
                                                                                        disabled={
                                                                                            this.state.returnItems.filter(
                                                                                                i => i.lineItemId === li.line_item_id
                                                                                            )[0] &&
                                                                                            this.state.returnItems.filter(
                                                                                                i => i.lineItemId === li.line_item_id
                                                                                            )[0].quantity ===
                                                                                                li.quantity - li.fulfillable_quantity
                                                                                        }
                                                                                        onClick={this.handleReturnItemAddClick.bind(this, li)}
                                                                                        className="return-item-quantity-change-button"
                                                                                        color="primary"
                                                                                    >
                                                                                        <AddIcon />
                                                                                    </Button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                                        <div style={{ fontSize: "11px", color: "rgba(0, 0, 0, 0.54)", margin: "5px 0px 10px 0px" }}>
                                                            {
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS
                                                                    .EGIFTCARDS_PRESENT_MESSAGE
                                                            }
                                                        </div>
                                                    )}
                                                    {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "return_items") && (
                                                        <FormHelperText className="custom-helper-text">
                                                            {this.state.submitErrors.find(e => e.code === "return_items").label}
                                                        </FormHelperText>
                                                    )}
                                                    <div className="return-reason-box">
                                                        <div className="layout vertical custom-select-box">
                                                            <InputLabel className={`custom-select-label`}>{`* ${
                                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.REASON_HEADER
                                                            }`}</InputLabel>
                                                            <Select
                                                                classes={{
                                                                    selectMenu: "custom-select-menu"
                                                                }}
                                                                name="return-reason"
                                                                MenuProps={{
                                                                    variant: "menu",
                                                                    getContentAnchorEl: null,
                                                                    classes: {
                                                                        paper: "custom-select-menu-paper"
                                                                    }
                                                                }}
                                                                className="custom-select"
                                                                disabled={false}
                                                                value={this.state.returnReasonId || -1}
                                                                onChange={this.handleChange.bind(this)}
                                                            >
                                                                {this.props.returnReasons &&
                                                                    this.props.returnReasons.length > 0 &&
                                                                    this.props.returnReasons.map((returnReason, i) => {
                                                                        return (
                                                                            <MenuItem
                                                                                key={i}
                                                                                className="form-menu-item-select-multiple"
                                                                                value={returnReason.id}
                                                                            >
                                                                                <ListItemText
                                                                                    classes={{
                                                                                        root: "form-menu-item-select-multiple-list-item-text"
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        locales[this.props.store[0]][this.props.language].ORDER_PAGE
                                                                                            .RETURN_SECTION.REASONS[returnReason.code]
                                                                                    }
                                                                                </ListItemText>
                                                                            </MenuItem>
                                                                        );
                                                                    })}
                                                                )
                                                            </Select>
                                                            {this.state.submitErrors.length > 0 &&
                                                                this.state.submitErrors.find(e => e.code === "return_reason") && (
                                                                    <FormHelperText>
                                                                        {this.state.submitErrors.find(e => e.code === "return_reason").label}
                                                                    </FormHelperText>
                                                                )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="return-window-calculation-summary" className="layout vertical return-window-calculation-summary">
                                                    <div className="layout horizontal justified">
                                                        <div className="section-title">
                                                            {locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.REFUND_SUMMARY.HEADING}
                                                        </div>
                                                    </div>
                                                    <div className="layout horizontal return-window-calculation-summary-breakdown">
                                                        <table className="flex layout vertical ">
                                                            <tbody className="flex layout vertical">
                                                                <tr className="layout horizontal item">
                                                                    <td className="flex layout return-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION
                                                                                .REFUND_SUMMARY.ITEMS_SUBTOTAL_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="flex layout return-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION
                                                                                .REFUND_SUMMARY.SHIPPING_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="flex layout return-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION
                                                                                .REFUND_SUMMARY.TAXES_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>

                                                                <tr className={`layout horizontal item refund-total-row`}>
                                                                    <td className="flex layout return-window-calculation-summary-label">
                                                                        {`${
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION
                                                                                .REFUND_SUMMARY.REFUND_TOTAL_TITLE
                                                                        }:`}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                        <table className="layout vertical ">
                                                            <tbody className="flex layout vertical end">
                                                                <tr className="layout horizontal item">
                                                                    <td className="return-window-calculation-summary-number">
                                                                        {this.props.returnOrderCalculateData
                                                                            ? this.props.returnOrderCalculateData.total_line_items_price_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="return-window-calculation-summary-number">
                                                                        {this.props.returnOrderCalculateData
                                                                            ? this.props.returnOrderCalculateData.total_shipping_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>
                                                                <tr className="layout horizontal item">
                                                                    <td className="return-window-calculation-summary-number">
                                                                        {this.props.returnOrderCalculateData
                                                                            ? this.props.returnOrderCalculateData.total_tax_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>

                                                                <tr className="layout horizontal item refund-total-row">
                                                                    <td className="return-window-calculation-summary-number">
                                                                        {this.props.returnOrderCalculateData
                                                                            ? this.props.returnOrderCalculateData.total_price_formatted
                                                                            : null}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    id="sticky-refund-total-return-order"
                                    className={`sticky-refund-total-return-order relative${!this.state.scrolling ? " not-scrolling" : ""}`}
                                >
                                    <div className={`sticky-refund-total-return-order-inner-2${!this.state.scrolling ? " not-scrolling" : ""}`} />
                                    <div className="flex layout horizontal end">
                                        <div className="flex layout return-window-calculation-summary-label">
                                            {`${
                                                locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.REFUND_SUMMARY.REFUND_TOTAL_TITLE
                                            }:`}
                                        </div>
                                        <div className="return-window-calculation-summary-number">
                                            {this.props.returnOrderCalculateData ? this.props.returnOrderCalculateData.total_price_formatted : null}
                                        </div>
                                    </div>
                                </div>
                                <div id="buttons-1" className="box">
                                    <div className="row">
                                        <div className="column">
                                            <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                                <div className="layout vertical center-center inbutton-text">
                                                    {locales[this.props.store[0]][this.props.language].MISC.CLOSE}
                                                </div>
                                            </button>
                                        </div>
                                        <div className="column">
                                            <button
                                                className={`custom-button ${this.props.loading ? "loading" : ""}`}
                                                style={{ float: "right" }}
                                                onClick={this.props.loading ? null : this.handleYesClick.bind(this)}
                                            >
                                                <div className="layout vertical center-center inbutton-text">
                                                    {locales[this.props.store[0]][this.props.language].MISC.SUBMIT}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.returnFinished && (
                            <div>
                                <div>
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div className="message-box">
                                                    {
                                                        locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS
                                                            .SUCCESS_MESSAGE
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                                    <div className="layout vertical center-center inbutton-text">
                                                        {locales[this.props.store[0]][this.props.language].MISC.CLOSE}
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <ConfirmationWindow
                            open={this.state.confirmationWindowOpen}
                            handleClose={this.handleCloseConfirmationWindow.bind(this)}
                            handleSubmit={this.handleConfirmReturnOrder.bind(this)}
                            loading={this.props.loading}
                            heading={locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.CONFIRMATION.HEADING}
                            subheading={locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER_ITEMS.CONFIRMATION.SUBHEADING}
                            noText={locales[this.props.store[0]][this.props.language].MISC.NO}
                            yesText={locales[this.props.store[0]][this.props.language].MISC.YES}
                        />
                        <DataConflictWindow
                            open={this.state.dataConflictWindowOpen}
                            handleSubmit={this.handleRefreshOrder.bind(this)}
                            heading={locales[this.props.store[0]][this.props.language].DATA_CONFLICT.HEADING}
                            subheading={locales[this.props.store[0]][this.props.language].DATA_CONFLICT.SUB_HEADING}
                            yesText={locales[this.props.store[0]][this.props.language].MISC.REFRESH}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(ReturnOrderItemsWindow);



// WEBPACK FOOTER //
// ./src/views/Order/components/_ReturnOrderItemsWindow.jsx